import { render } from "./ChurchMap.vue?vue&type=template&id=61de4f36&scoped=true"
import script from "./ChurchMap.vue?vue&type=script&lang=js"
export * from "./ChurchMap.vue?vue&type=script&lang=js"

import "./ChurchMap.vue?vue&type=style&index=0&id=61de4f36&scoped=true&lang=css"
import "./ChurchMap.vue?vue&type=style&index=1&id=61de4f36&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61de4f36"]])

export default __exports__